

/** This will be replaced by the types information JSON */
const __needleTypesJson: unknown = /* @_TYPES_START */[]; /* @_TYPES_END */

let typesInfo: Map<string, NeedleTypeEntry> | null = null;

type NeedleTypeEntry = {
    file: string,
    name: string,
    group: string,
    kindString: string,
    category: string | string[],
    comment: {
        kind: "text",
        shortText: string,
        text: string,
    },
    children: Array<{
        name: string,
        kindString: "Property" | ({} & string),
        propertyType: string,
        comment: {
            kind: "text",
            shortText: string,
            text?: string,
        }
    }>,

    __description_text?: string;
}

function parseTypes(): void {
    if (typesInfo !== null) {
        return;
    }
    typesInfo = new Map<string, NeedleTypeEntry>();
    try {
        const obj = typeof __needleTypesJson !== "string" ? __needleTypesJson : JSON.parse(__needleTypesJson) as Array<NeedleTypeEntry>;
        if (Array.isArray(obj)) {
            typesInfo = new Map<string, NeedleTypeEntry>();
            for (const entry of obj) {
                typesInfo.set(entry.name, entry);
            }
        }
        else if (obj) {
            console.debug("Unknown types format");
        }

    } catch (e) {
        // ignore
    }
}

export namespace NeedleMeta {

    export function getNeedleTypeMeta(name: string) {
        parseTypes();
        return typesInfo?.get(name);
    }

    export function getPropertyDescription(componentName: string, propertyName: string) {
        const typeInfo = getNeedleTypeMeta(componentName);
        if (!typeInfo) return null;
        const propInfo = typeInfo.children.find(c => c.name === propertyName);
        if (!propInfo) return null;
        return propInfo.comment?.text || propInfo.comment.shortText || null;
    }

    export function getTypeDescriptionShort(name: string): string | null {
        const typeInfo = getNeedleTypeMeta(name);
        if (!typeInfo) return null;

        if (typeInfo.__description_text) return typeInfo.__description_text;

        const longText = typeInfo.comment?.text;
        if (longText) {
            typeInfo.__description_text = parseLongText(longText, 250);
        }
        else if (typeInfo.comment?.shortText) {
            typeInfo.__description_text = typeInfo.comment.shortText;
        }


        return typeInfo.__description_text || null;

        function parseLongText(text: string, maxLength: number): string {
            let newText = "";
            const lines = text.split("\n");
            for (const line of lines) {
                const trimmed = line.trim();
                if (trimmed.length === 0) continue;

                // if we encounter a list or section, stop parsing
                if (
                    trimmed.startsWith("-") ||
                    trimmed.startsWith("#") ||
                    trimmed.startsWith("*")
                ) break;

                newText += trimmed + " ";
                if (newText.length > maxLength) {
                    newText = newText.substring(0, maxLength - 3) + "...";
                    break;
                }
            }

            if (newText.length <= 0) {
                if (typeInfo?.comment?.shortText) {
                    return typeInfo.comment.shortText;
                }
                if (text.length > maxLength) newText = text.substring(0, maxLength - 3) + "...";
                else return text;
            }

            return newText.trim();
        }
    }
}

